import { delay } from 'redux-saga/effects';
import { take, put, call, race } from 'redux-saga/effects';
import { push as navigateTo } from 'connected-react-router';
import { Actions, loginSuccess, loginFailure, logoutSuccess, logoutFailure, loginRequest } from 'actions/sessionActions';
import { apiPost } from './apiSagas';
import { Errors } from 'shared/errors';
import { toError } from 'shared/util/toError';
import { featuresLoaded } from 'actions/featuresActions';
import { SagaIterator } from "redux-saga";

export function* loginSaga() {
    while (true) {
        const action: ReturnType<typeof loginRequest> = yield take(Actions.LOGIN_REQUEST);
        const { callback } = action.payload;

        try {
            const { result } = yield race({
                result: call(apiPost, '/api/login', {}),
                timeout: delay(5000),
            });
            if (!result) {
                throw new Error(Errors.TIMEOUT);
            }
            const { session, features } = result;
            const { user, permissions } = session;
            yield put(loginSuccess({ user, permissions }));
            yield put(featuresLoaded(features));
        }
        catch (e) {
            const err = toError(e);
            yield put(loginFailure(err));
        }

        callback();
    }
}

export function* logoutSaga(): SagaIterator {
    while (true) {
        // Wait for the user to logout
        yield take(Actions.LOGOUT_REQUEST);
        try {
            const result = yield call(apiPost as any, '/api/logout');

            if (result?.redirectUrl) {
                window.location.href = result.redirectUrl;
            }

            yield put(logoutSuccess());
            yield put(navigateTo('/login'));
        }
        catch (e) {
            const err = toError(e);
            yield put(logoutFailure(err));
        }
    }
}
